export const isKioskDevice = () => !!localStorage.getItem('myriadIsKiosk');

export const clearStoragePreserveKiosk = () => {
  const kiosk = isKioskDevice();
  localStorage.clear();
  if (kiosk) localStorage.setItem('myriadIsKiosk', 'true');
};
